import { MDS_COLORS_BACKGROUND_INVERSE, MDS_COLORS_BACKGROUND_RECOMMENDATION_WEAK, MDS_COLORS_CHART_BLUE_01, MDS_COLORS_CHART_BLUE_02, MDS_COLORS_CHART_PURPLE_01, MDS_COLORS_INK_ACCENT_HOVER, MDS_COLORS_INK_DEFAULT, MDS_COLORS_INK_ERROR, MDS_COLORS_INK_RECOMMENDATION, MDS_COLORS_LINE_BORDER, MDS_COLORS_SURFACE_LAYER_02, } from '@rappi/mustache-b2b-foundations';
import { Typography } from '@rappi/rests-commons-front';
import styled from 'styled-components';
export const Container = styled.div `
  width: 100%;
  min-height: 96px;
  display: flex;
  align-items: center;
  border-radius: 16px;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ $state, $aiScrapper }) => $state === 'hover'
    ? $aiScrapper
        ? MDS_COLORS_INK_RECOMMENDATION
        : MDS_COLORS_CHART_BLUE_02
    : MDS_COLORS_LINE_BORDER};
  background: ${MDS_COLORS_BACKGROUND_INVERSE};
  transition: all 0.2s;
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  overflow: hidden;
`;
export const IconContainer = styled.div `
  width: 80px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  background-color: ${({ $state, $aiScrapper }) => {
    switch ($state) {
        case 'hover':
            return $aiScrapper ? MDS_COLORS_CHART_PURPLE_01 : MDS_COLORS_CHART_BLUE_02;
        default:
            return MDS_COLORS_SURFACE_LAYER_02;
    }
}};
`;
export const ContentContainer = styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  gap: 32px;
  transition: all 0.2s;
  background-color: ${({ $state, $aiScrapper }) => {
    switch ($state) {
        case 'hover':
            return $aiScrapper ? MDS_COLORS_BACKGROUND_RECOMMENDATION_WEAK : MDS_COLORS_CHART_BLUE_01;
        default:
            return MDS_COLORS_BACKGROUND_INVERSE;
    }
}};
`;
export const Label = styled(Typography) `
  color: ${({ $state, $aiScrapper }) => {
    switch ($state) {
        case 'error-weight':
        case 'error-file':
        case 'error-execution':
            return MDS_COLORS_INK_ERROR;
        case 'done':
            return MDS_COLORS_INK_DEFAULT;
        case 'hover':
            return $aiScrapper ? MDS_COLORS_INK_RECOMMENDATION : MDS_COLORS_INK_ACCENT_HOVER;
        default:
            return $aiScrapper ? MDS_COLORS_INK_RECOMMENDATION : MDS_COLORS_INK_DEFAULT;
    }
}};
  font-weight: ${({ $state, $aiScrapper }) => $state === 'error-weight' || $state === 'error-file' || ($state === 'loading' && $aiScrapper) ? 600 : 400};
`;
export const CloseButton = styled.button `
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
